import type { Booking } from "@/lib/bookings";

interface BookingStatsProps {
  bookings: Booking[];
}

const CARD_TONES: Record<string, { bubble: string; value: string }> = {
  primary: { bubble: "bg-primary-100 text-primary-700", value: "text-foreground-950" },
  accent: { bubble: "bg-accent-100 text-accent-900", value: "text-foreground-950" },
  secondary: { bubble: "bg-secondary-100 text-secondary-700", value: "text-foreground-950" },
};

export default function BookingStats({ bookings }: BookingStatsProps) {
  const count = (status: string) => bookings.filter((b) => b.status === status).length;

  const cards = [
    {
      label: "Total bookings",
      value: bookings.length,
      icon: "ri-calendar-check-line",
      tone: "primary",
    },
    {
      label: "New requests",
      value: count("new"),
      icon: "ri-notification-3-line",
      tone: "accent",
    },
    {
      label: "Confirmed",
      value: count("confirmed"),
      icon: "ri-checkbox-circle-line",
      tone: "primary",
    },
    {
      label: "Completed",
      value: count("completed"),
      icon: "ri-plant-line",
      tone: "secondary",
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5">
      {cards.map((card) => {
        const tone = CARD_TONES[card.tone];
        return (
          <div
            key={card.label}
            className="bg-background-50 border border-background-200 rounded-lg p-4 md:p-5"
          >
            <span
              className={`w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-full ${tone.bubble}`}
            >
              <i className={`${card.icon} text-xl`}></i>
            </span>
            <p className={`font-heading text-3xl md:text-4xl font-semibold mt-4 ${tone.value}`}>
              {card.value}
            </p>
            <p className="text-xs md:text-sm text-foreground-600 mt-1">{card.label}</p>
          </div>
        );
      })}
    </div>
  );
}